import AccordionRightContent from "@frameworks/web/components/generic/Accordion/AccordionRightContent";
import React from "react";
import DpInterestTable from "./DpInterestTable";
import { useSelector } from "react-redux";
import dpInterestDi from "@frameworks/web/components/Reports/DpInterest/di/servicelocator";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import { threePaths } from "./DpInterestMobileTable";
const DpInterestAccordion = (props) => {
    var _a;
    const { reducersData: dpiCharges, commonData: chargesCommonData } = useSelector((state) => state.DpInterest.dpiCharges);
    const { reducersData: dpiDetails, commonData: detailsCommonData } = useSelector((state) => state.DpInterest.dpiDetails);
    const [clickedMonth, setClickedMonth] = React.useState("");
    const selectedFamilyMember = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.FamilyTagging.familyDetails) === null || _a === void 0 ? void 0 : _a.reducersData) === null || _b === void 0 ? void 0 : _b.selectedMember) === null || _c === void 0 ? void 0 : _c.accCode; });
    const paths = Array(3)
        .fill("")
        .map((_, idx) => React.createElement("span", { key: idx, className: `path${idx + 1}` }));
    const dpiChargeDetails = (_a = dpiCharges === null || dpiCharges === void 0 ? void 0 : dpiCharges.dpiCharges) === null || _a === void 0 ? void 0 : _a.map((x) => {
        return {
            title: x.monthYear,
            rightContent: x.interestAmount,
            tabContent: React.createElement(DpInterestTable, { data: dpiDetails === null || dpiDetails === void 0 ? void 0 : dpiDetails.dpiDetails }),
            eventKey: x.monthYear,
        };
    });
    React.useEffect(() => {
        if (clickedMonth) {
            let payload = {
                dpType: props.dpType,
                month: clickedMonth,
                accCode: selectedFamilyMember,
            };
            dpInterestDi.dpInterest.getDpInterestDetails(payload);
        }
    }, [clickedMonth, props.dpType]);
    return (React.createElement("div", { className: "dp-interest-accordion-mainblock" },
        React.createElement("div", { className: "flexJustifySpaceBetween DMSansMedium_12_500 txt_primaryGrey title-head" },
            React.createElement("div", null, "Month - Year"),
            React.createElement("div", null, "Interest Amount (Rs.)")),
        chargesCommonData.loader ? (React.createElement(Common_Shimmer, null)) : chargesCommonData.errorData.isOpen ? (React.createElement(ErrorNotification, { error: chargesCommonData.errorData.error, isOpen: chargesCommonData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION })) : chargesCommonData.message.show ? (React.createElement("div", { className: "error-msg-new-icon" },
            React.createElement(Errormsg, { customMsg: React.createElement("div", { className: "DMSan_14_700 txt-midnight-blue" },
                    "No results found!",
                    React.createElement("div", { className: "DMSanN_14_400 txt_secondary-gray" }, "Try searching for something else")), paths: threePaths, icon: "edel-icon-reports-note" }))) : (React.createElement("div", { className: "dp-interest-accordion" },
            React.createElement(AccordionRightContent, { defaultActiveKey: clickedMonth, handleTitle: setClickedMonth, AccordionArray: dpiChargeDetails, parentClass: "common-accordian-small-content mgt-10" })))));
};
export default DpInterestAccordion;
